const menus = [
    {
        id: 1,
        name: 'Presale ',
        links: '/presale'
    },
    {
        id: 2,
        name: 'Airdrop ',
        links: '/airdrop'
    },
    {
        id: 3,
        name: 'Stake ',
        links: '/stake'
    },
    {
        id: 4,
        name: 'Vaults ',
        links: '/vaults'
    }, 
    {
        id: 5,
        name: 'Contracts ',
        links: '/contracts'
    },

]

export default menus;